import React, { useEffect, useState } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { navData } from '../../data/mock';
import Logo from './Logo';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur border-b border-[#12367F]/10' : 'bg-transparent'
      }`}
    >
      <div className="container-x flex items-center justify-between px-6 py-4 md:py-5">
        <Link to="/" className="flex items-center group">
          <Logo size={32} />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {navData.groups.map((group) => (
            <div
              key={group.label}
              className="relative"
              onMouseEnter={() => setActiveMenu(group.label)}
              onMouseLeave={() => setActiveMenu(null)}
            >
              <button
                className="px-4 py-2 text-sm font-medium rounded-full text-[#12367F] hover:bg-[#12367F] hover:text-white transition-colors"
              >
                {group.label}
              </button>
              {activeMenu === group.label && (
                <div className="absolute left-0 top-full pt-2 min-w-[220px]">
                  <div className="bg-white border border-[#12367F]/10 rounded-2xl shadow-lg p-2">
                    {group.items.map((item) => (
                      <a
                        key={item.label}
                        href={item.href}
                        className="flex items-center justify-between px-4 py-2.5 text-sm rounded-xl text-[#12367F] hover:bg-[#2EF5FF] transition-colors"
                      >
                        {item.label}
                        <ArrowUpRight className="h-4 w-4 opacity-0 group-hover:opacity-100" />
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a href={navData.cta.href} className="btn-base btn-primary">
            {navData.cta.label}
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>

        <button
          aria-label="Toggle menu"
          className="lg:hidden p-2 rounded-full border border-[#12367F]/20 text-[#12367F]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-white border-t border-[#12367F]/10">
          <div className="px-6 py-6 space-y-6">
            {navData.groups.map((g) => (
              <div key={g.label}>
                <p className="font-display text-2xl text-[#12367F]">{g.label}</p>
                <div className="mt-2 grid grid-cols-2 gap-2">
                  {g.items.map((i) => (
                    <a key={i.label} href={i.href} className="text-sm text-[#12367F]/80 hover:text-[#12367F]">
                      {i.label}
                    </a>
                  ))}
                </div>
              </div>
            ))}
            <a href={navData.cta.href} className="btn-base btn-primary w-full justify-center">
              {navData.cta.label}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
